var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 11.7692V15.2564C14.85 16.218 14.0427 17 13.05 17C12.0573 17 11.25 16.218 11.25 15.2564V11.7692C11.25 10.8076 12.0573 10.0256 13.05 10.0256C14.0427 10.0256 14.85 10.8076 14.85 11.7692ZM4.95 10.0256C3.9573 10.0256 3.15 10.8076 3.15 11.7692V15.2564C3.15 16.218 3.9573 17 4.95 17C5.9427 17 6.75 16.218 6.75 15.2564V11.7692C6.75 10.8076 5.9427 10.0256 4.95 10.0256ZM9 0C4.0374 0 0 3.91087 0 8.71795V13.0769C0 13.559 0.4032 13.9487 0.9 13.9487C1.3968 13.9487 1.8 13.559 1.8 13.0769V8.71795C1.8 4.87246 5.0301 1.74359 9 1.74359C12.9699 1.74359 16.2 4.87246 16.2 8.71795V13.0769C16.2 13.559 16.6032 13.9487 17.1 13.9487C17.5968 13.9487 18 13.559 18 13.0769V8.71795C18 3.91087 13.9626 0 9 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadPhone);
export default __webpack_public_path__ + "static/media/headPhone.91382061d4c31bf786a1c4c153cb1117.svg";
export { ForwardRef as ReactComponent };